export default __webpack_public_path__ + "static/media/yuryu-03.bb641632.svg";